import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatRupiah } from "../lib/api";

const CATEGORIES = [
  { value: "", label: "Semua" },
  { value: "journaling", label: "Journaling" },
  { value: "mood_tracker", label: "Mood Tracker" },
  { value: "hr_template", label: "HR Templates" },
];

export default function Products() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("");
  useEffect(() => {
    api.get(`/products${cat ? `?category=${cat}` : ""}`).then(r => setProducts(r.data));
  }, [cat]);

  return (
    <div data-testid="products-page">
      <section className="lumina-bg-soft py-20">
        <div className="lumina-container">
          <div className="lumina-label mb-3">Produk Digital</div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#1A1728] mb-6 max-w-3xl">Journaling, mood tracker, & HR templates yang dibuat penuh hati.</h1>
          <div className="flex flex-wrap gap-3 mt-10">
            {CATEGORIES.map(c => (
              <button key={c.value} onClick={() => setCat(c.value)}
                data-testid={`filter-${c.value || "all"}`}
                className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${cat === c.value ? "bg-[#6B4BA3] text-white" : "bg-white border border-[#E2DFED] text-[#5C5870] hover:border-[#6B4BA3]"}`}>
                {c.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="lumina-container py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map(p => (
            <Link to={`/products/${p.slug}`} key={p.id} className="lumina-card overflow-hidden group" data-testid={`product-card-${p.slug}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <span className="lumina-label">{p.category.replace("_", " ")}</span>
                <h3 className="font-serif text-2xl text-[#1A1728] mt-2 mb-3 leading-tight">{p.title}</h3>
                <p className="text-sm text-[#5C5870] leading-relaxed mb-4 line-clamp-2">{p.description}</p>
                <div className="flex items-baseline gap-2">
                  <span className="text-[#6B4BA3] font-semibold text-lg">{formatRupiah(p.price)}</span>
                  {p.original_price && p.original_price > p.price && <span className="text-[#5C5870] line-through text-sm">{formatRupiah(p.original_price)}</span>}
                </div>
              </div>
            </Link>
          ))}
        </div>
        {products.length === 0 && <p className="text-center text-[#5C5870] py-20">Belum ada produk di kategori ini.</p>}
      </section>
    </div>
  );
}
